import React, {Component} from "react";
import {withTranslation} from "react-i18next";
import Table from "../../../components/table/Table";
import OggettiUtili from "../../../utils/OggettiUtili.json";
import styles from "../ReportStatistici.module.css";
import Utils from "../../../utils/Utils";
import ReportEpatiteService from "../../../services/ReportEpatiteService";
import Spinner from "../../../components/spinner/Spinner";
import Icon from "../../../components/icon/Icon";
import ToasterSingleton from "../../../singleton/ToasterSingleton";
import toasterConfig from "../../../config/toasterConfig";

class ReportEpatite extends Component {

  state={
      rowsTable: [],
      cols:[],
      totalElements:0,
      page:0,
      totalPages:0,
      size:10,
      loading:false,
      sendRequest:false,
      report:{},
      filtri:{}

  }
    cols = [
        {key: "tipo", name: "Tipo report", sortDirection: "none"},
        {key: "periodo", name: "Periodo di riferimento", sortDirection: "none"},
        {key: "nomeFile", name: "Nome file", sortDirection: "none"},
        {key: "inoltrato", name: "Inoltrato", tipo: "checkbox",sortDirection: "none"},
        {key: "scarica", name: "", tipo: "icon", style:{fill: "#1b7ea9", alignItems:"center", marginBottom:"0.5rem"}, id:"it-download", classes:"icon-sm"},
        {key: "elimina", name: "", tipo: "icon", style:{fill: "red", alignItems:"center", marginBottom:"0.5rem"}, id:"it-delete", classes:"icon-sm", idElemento:"idReport"}
    ]

    rows={
        data: {
            id: "dataDa",
            id1: "dataA",
            radioNav: "si",
            text: "Data di inizio sintomi",
            text1: "Data di segnalazione",
            fieldDataDa: "dataDa",
            fieldDataA: "dataA",
            placeholder: "segnalazione da",
            placeholder1: "segnalazione a"
        },
        tipo: {
            id: "tipo",
            field: "tipo",
            text: "Tipo"
        },
    }

    constructor(props) {
        super(props);
        this.setStateGenerico = this.setStateGenerico.bind(this);
        this.changePageTable=this.changePageTable.bind(this);
        this.mapDatiPerTabella=this.mapDatiPerTabella.bind(this);
        this.createJsonReport=this.createJsonReport.bind(this);
        this.getTabella=this.getTabella.bind(this);
        this.aggiungiToaster=this.aggiungiToaster.bind(this);
        this.onClickButtonsTabella=this.onClickButtonsTabella.bind(this);
        this.riceviValoreInoltrato=this.riceviValoreInoltrato.bind(this);
    }

    componentDidMount() {
        ToasterSingleton.instance().sottoscrizione(this)
      this.setState({loading:true})
      let pagination= {
          paginazione : true
      }
        this.getTabella(pagination);
        let object = {
            stato: this.state.filtri,
            setStatePadre: this.setStateGenerico,
            rows: this.rows,
            applicaFiltri: () => {this.sendRequest()}
        }
        this.props.creaFiltri({filtri: object})
    }

    setStateGenerico(object) {
        this.setState(object)
    }

    getTabella(pagination){
        ReportEpatiteService.getReportEpatite(pagination)
            .then((data) => {
                let rows=this.mapDatiPerTabella(data.data.content)
                this.setState({
                    rowsTable: rows, totalElements: data.data.totalElements,
                    totalPages: data.data.totalPages, page: pagination.page,
                    loading: false
                });
            })
            .catch(() => {
                console.log("[Error] GetReportEpatite in errore ");
                this.setState({loading:false})
            })
    }

    riceviValoreInoltrato(row){
        this.setState({loading: true})
        let jsonInsert={...row}
        jsonInsert.tipo=parseInt(OggettiUtili.reportEpatiteTipoPerDescrizione[row.tipo]);
        ReportEpatiteService.putReportEpatite(row.idReport, jsonInsert)
            .then((data)=>{
                let pagination = {
                    paginazione: true,
                    size: this.state.size,
                    page: 0
                }
                this.getTabella(pagination);
            })
            .catch(()=>{
                this.setState({loading: false})
            })
    }
    onClickButtonsTabella(row,event){
      let id=event.currentTarget.id;
        this.setState({loading: true})
      if (id.includes("it-delete")) {
          ReportEpatiteService.deleteReportEpatite(row.idReport)
              .then((data) => {
                  let pagination = {
                      paginazione: true,
                      size: this.state.size,
                      page: 0
                  }
                  this.getTabella(pagination);
              })
              .catch(() => {
                  this.setState({loading: false})
              })
      } else {
          let dataDa=Utils.transformDateForBackend(row.dataDa).replaceAll("/","-");
          let dataA=Utils.transformDateForBackend(row.dataA).replaceAll("/","-");
          let params={
              tipo:OggettiUtili.reportEpatiteTipoPerDescrizione[row.tipo],
              dataDa:dataDa,
              dataA:dataA
          }
          ReportEpatiteService.getExportReportEpatite(params)
              .then((res)=>{
                  if (res.status===200){
                      Utils.downloadReport(res.data.stream,res.data.descrizione,res.data.formato)

                  }
                  this.setState({loading: false})
              })
              .catch(() => {
                  this.setState({loading: false})
                  return this.aggiungiToaster("Non sono presenti segnalazioni per il tipo e il periodo selezionato");
              });
      }

    }
    createJsonReport() {
      let dataDa=this.state.filtri.dataDa;
        let dataA=this.state.filtri.dataA;
        let ObjectForBackEnd = {}
        ObjectForBackEnd["dataDa"] =dataDa.replace(/(\d{2})\/(\d{2})\/(\d{4})/, "$3/$2/$1");
        ObjectForBackEnd["tipo"] = parseInt(this.state.filtri.tipo);
        ObjectForBackEnd["inoltrato"] = false;
        ObjectForBackEnd["dataA"] = dataA.replace(/(\d{2})\/(\d{2})\/(\d{4})/, "$3/$2/$1");

        return Utils.removeEmptyValueFromObject(ObjectForBackEnd)
    }

    aggiungiToaster(text) {

        ToasterSingleton.instance().aggiuntaToaster({
            type: toasterConfig.types.confirm,
            text: text,
            timestamp: Date.now()
        })
    }

    sendRequest() {
        if (this.state.filtri && this.state.filtri.dataDa && this.state.filtri.dataA && Utils.checkDateInterval(this.state.filtri.dataA, this.state.filtri.dataDa)) {
            return this.aggiungiToaster("Il campo \"Data Da\" deve essere minore del campo \"Data A\"")
        } else {
            this.setState({loading: true})
            let pagination = {
                paginazione: true,
                size: this.state.size,
                page: 0
            }
            let dataDa=Utils.transformDateForBackend(this.state.filtri.dataDa)
            let dataA=Utils.transformDateForBackend(this.state.filtri.dataA)

            let params={
                tipo:this.state.filtri.tipo,
                dataDa:dataDa,
                dataA:dataA
            }
            ReportEpatiteService.getExportReportEpatite(params)
                .then((res)=>{
              if (res.status===200){
                  Utils.downloadReport(res.data.stream,res.data.descrizione,res.data.formato)
                  let jsonReport = this.createJsonReport();
                  ReportEpatiteService.postInserimentoReportEpatite(jsonReport)
                      .then((data) => {
                          console.log("Report inserito correttamente")
                          this.getTabella(pagination);
                      })
                      .catch(() => {
                          console.log("[Error] PostReportEpatitein errore ");
                          this.setState({loading: false})
                      });

              }
            })
                .catch(() => {
                this.setState({loading: false})
                    return this.aggiungiToaster("Non sono presenti segnalazioni per il tipo e il periodo selezionato");

                });

        }
    }


    changePageTable(sort, direction, page, size) {
        this.setState({loading:true})
        let params = {
            page:page,
            size:size,
            paginazione: true
        }
        if (sort){
            params.sort=sort
        }
        if (direction){
            params.order=direction
        }
        this.getTabella(params);
    }

     mapDatiPerTabella(rows){
      rows.forEach(object =>{
          let dataDa=object.dataDa.replaceAll("/","-")
          let dataA=object.dataA.replaceAll("/","-")
          let tipo=OggettiUtili.reportEpatiteTipo[object.tipo]
          object.tipo=tipo
          object.periodo=Utils.transformDateForFrontend(dataDa)+" - "+Utils.transformDateForFrontend(dataA)
      })
    return rows
    }

  render() {
      const {t}=this.props;

      const tableDiv = (
          <div className="container mt-3">
              <div className={styles.contenitoreTabella} style={{marginTop: "2px"}}>
                  <Table
                      id={"reportTable"}
                      cols={this.cols}
                      rows={this.state.rowsTable}
                      empty={this.state.rowsTable && this.state.rowsTable.length === 0}
                      onSelectCheckbox={this.riceviValoreInoltrato}
                      emptyMsg={"Non sono presenti report da visualizzare"}
                      lengthEditable={true}
                      bigTable={true}
                      homePage={true}
                      onClickIcon={this.onClickButtonsTabella}
                      reportStatistici={true}
                      totalElements={this.state.totalElements}
                      totalPages={this.state.totalPages}
                      page={this.state.page}
                      changePage={this.changePageTable}
                      changePagination={this.changePageTable}
                  />
              </div>
          </div>
      );
      
      return (<div>
          {ToasterSingleton.instance().renderToaster()}
          {this.state.loading ?
              (<div><Spinner/></div>) : (<div/>)}
          {tableDiv}
      </div>);
  }


}
export default withTranslation('common')(ReportEpatite)